import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import type { ChartBarSeries, ChartDataPoint, ChartLayout } from "../../types/reports.types";

interface BarChartCardProps {
  data?: ChartDataPoint[];
  bars?: ChartBarSeries[];
  layout?: ChartLayout;
  loading?: boolean;
}

export default function BarChartCard({
  data = [],
  bars = [],
  layout = "horizontal",
  loading = false,
}: BarChartCardProps) {
  if (loading) {
    return <div className="chartState">Loading chart...</div>;
  }

  if (!data.length || !bars.length) {
    return <div className="chartState empty">No comparison data available</div>;
  }

  const isVertical = layout === "vertical";

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        layout={layout}
        margin={{ top: 10, right: 10, left: isVertical ? 20 : 0, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e6edf4" />
        <XAxis
          type={isVertical ? "number" : "category"}
          dataKey={isVertical ? undefined : "name"}
          tick={{ fontSize: 10 }}
        />
        <YAxis
          type={isVertical ? "category" : "number"}
          dataKey={isVertical ? "name" : undefined}
          width={isVertical ? 130 : 40}
          tick={{ fontSize: 10 }}
        />
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 10 }} />
        {bars.map((series) => (
          <Bar
            key={series.dataKey}
            dataKey={series.dataKey}
            name={series.name}
            fill={series.color}
            radius={[4, 4, 0, 0]}
            isAnimationActive
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
